import { BaseTenantEntity } from './base-raptor-models';

/**
 * Feature flag types available in the RAPTOR platform
 */
export enum FeatureFlagTypes {
    CheckIn = 'Check-In',
    Dispatch = 'Dispatch',
    DigitalVehicleInspection = 'Digital Vehicle Inspection',
    TimeClock = 'Time Clock',
    DailyClockIn = 'Daily Clock In',
    Inventory = 'Inventory',
    InventoryCount = 'Inventory Count',
    PurchaseOrderAndReceivingDocument = 'Purchase Order and Receiving Document',
    WorkOrder = 'Work Order',
    QuoteManagement = 'Quote Management',
    AuditLog = 'Audit Log',
    JobCategoryAdminEditing = 'Job Category Admin Editing',
    TechWorkView = 'Tech Work View',
    MobileDeviceAllowlisting = 'Mobile Device Allowlisting',
    SkipInspection = 'Skip Inspection',
    Import = 'Import',
    InspectionAutoSave = 'Inspection Auto Save',
    SelfCheckIn = 'Self Check-In',
    NationalSupplier = 'National Supplier',
    CustomerTexting = 'Customer Texting',
    CustomerTextMediaSend = 'Customer Text Media Send',
}

/**
 * Interface for Tenant Feature Flag
 */
export interface TenantFeatureFlag extends BaseTenantEntity {
    feature: FeatureFlagTypes | string;
    isEnabled: boolean;
    isPreview: boolean;
    /**
     * Immediate parent flag in the dependency tree, or undefined when the flag is a root.
     * Sourced from the backend, which reads its code-defined FeatureFlagParentMap.
     */
    parentFeature?: FeatureFlagTypes | null;
}

export function mockTenantFeatureFlagResponse(): TenantFeatureFlag[] {
    return [
        {
            id: '1',
            tenantId: 'tenant-1',
            feature: FeatureFlagTypes.DigitalVehicleInspection,
            isEnabled: true,
            isPreview: true,
            parentFeature: null,
        },
        {
            id: '2',
            tenantId: 'tenant-1',
            feature: FeatureFlagTypes.CheckIn,
            isEnabled: false,
            isPreview: false,
            parentFeature: null,
        },
        {
            id: '3',
            tenantId: 'tenant-1',
            feature: FeatureFlagTypes.Inventory,
            isEnabled: true,
            isPreview: false,
            parentFeature: null,
        },
        {
            id: '4',
            tenantId: 'tenant-1',
            feature: FeatureFlagTypes.SkipInspection,
            isEnabled: false,
            isPreview: false,
            parentFeature: FeatureFlagTypes.DigitalVehicleInspection,
        },
    ];
}
